let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("5uoHm"), load("1WRtl")]).then(() => parcelRequire('5KjQk'));